import { compact, truncate } from 'lodash';
import {
  isDevelopment,
} from '../../library/constants';
import {
  isNodeWithinViewport,
  capitalizeFirstLetter,
  findIndexInData,
  isMobilePhone,
  doWhenReady,
} from '../../library/calc';
import Mobile from './3_mobile';

class Move extends Mobile {

  designateDragOrDropTarget({mouseEvent}){
    const stageLeft =  Math.round(this.stage.current.position().x / this.stage.current.scaleX()) * -1;
    const stageTop =  (Math.round(this.stage.current.position().y / this.stage.current.scaleX()) * -1);
    const canvasTopDesktopMarginReal = this.props.canvasTop / this.stage.current.scaleX();

    const mouseX = mouseEvent.clientX;
    const mouseY = mouseEvent.clientY;

    // console.log(JSON.stringify({mouseX, mouseY}, null, 2));

    const realMouseX = stageLeft + Math.round( mouseX/ this.stage.current.scaleX());
    const realMouseY = stageTop + Math.round( mouseY/ this.stage.current.scaleX());

    let foundNode = false;
    for (let node in this.nodeObjsInViewPort) {

      if (!this.nodeObjs[node]) {
        console.warn(`Node object is undefined for node: ${node}`);
        continue;
      }

      const nodeTop = this.nodeObjs[node].top;
      const nodeRight = this.nodeObjs[node].right;
      const nodeBottom = this.nodeObjs[node].bottom;
      const nodeLeft = this.nodeObjs[node].left;

      if(
          parseInt(node, 10) > 0 &&
          realMouseX > nodeLeft &&
          realMouseX <  nodeRight &&
          realMouseY > nodeTop + canvasTopDesktopMarginReal &&
          realMouseY <  nodeBottom + canvasTopDesktopMarginReal
      ){


          if(this.mouseMovementActionForCntrlDnMoveFeature === 'find_drag'){


            if(!this.isNodeThatCanDragForCntrlMove({nodeObj: this.nodeObjs[node]})) {
              this.setCntrlDragNodeObj(node);
            }

          } else {

              if(this.cntrlDragNode !== node){

                const fromWhere = 'advanced dragging';
                this.highlight(node, fromWhere);
                this.setLastMouseOverTargetForDroppingCntrlDragNode(node);

              }

          }


        foundNode = true;

        break;

      } // END FOR

    };

    if(!foundNode) {
      if(this.mouseMovementActionForCntrlDnMoveFeature === 'find_drag') this.setCntrlDragNodeObj(null)
      this.dropOnTargetNode = undefined;
      this.unhighlight();
    }

  }

  mouseMovementActionForCntrlDnMoveFeature = 'find_drag'
  setMouseMovementActionMode_ForCntrlDnMoveFeature(how){
    this.mouseMovementActionForCntrlDnMoveFeature = how
  }

  buildChoicesArray(){

    const lengthLabel = 15;

    const father = truncate(capitalizeFirstLetter(this.translatedLabels['father'].translatedLabel), {
        length: lengthLabel,
        separator: ' '
    })

    const mother = truncate(capitalizeFirstLetter(this.translatedLabels['mother'].translatedLabel), {
        length: lengthLabel,
        separator: ' '
    })

    const husband = truncate(capitalizeFirstLetter(this.translatedLabels['husband'].translatedLabel), {
        length: lengthLabel,
        separator: ' '
    })

    const wife = truncate(capitalizeFirstLetter(this.translatedLabels['wife'].translatedLabel), {
        length: lengthLabel,
        separator: ' '
    })

    const brother = truncate(capitalizeFirstLetter(this.translatedLabels['brother'].translatedLabel), {
        length: lengthLabel,
        separator: ' '
    })

    const sister = truncate(capitalizeFirstLetter(this.translatedLabels['sister'].translatedLabel), {
        length: lengthLabel,
        separator: ' '
    })

    const son = truncate(capitalizeFirstLetter(this.translatedLabels['son'].translatedLabel), {
        length: lengthLabel,
        separator: ' '
    })

    const daughter = truncate(capitalizeFirstLetter(this.translatedLabels['daughter'].translatedLabel), {
        length: lengthLabel,
        separator: ' '
    })

    this.decisionChoicesArray = [
      {
        postLabel: 'parent',
        maleLabel: father,
        femaleLabel: mother,
        maleFile: 'father',
        femaleFile: 'mother'
      },
      {
        postLabel: 'partner',
        maleLabel: husband,
        femaleLabel: wife,
        maleFile: 'husband',
        femaleFile: 'wife',
      },
      {
        postLabel: 'sibling',
        maleLabel: brother,
        femaleLabel: sister,
        maleFile: 'brother',
        femaleFile: 'sister',
      },
      {
        postLabel: 'child',
        maleLabel: son,
        femaleLabel: daughter,
        maleFile: 'son',
        femaleFile: 'daughter',
      },
      {
        postLabel: 'same',
        maleLabel: this.translatedLabels['This person is the same.'].translatedLabel,
        isSamePerson: true,
      },
    ];
    window.decisionChoicesArray = this.decisionChoicesArray;
  }

  postToServer( relationship, marriageId ){

    if(isMobilePhone()){
      this.showProgressIndicator({fromWhere: 'postToServer'});
      const screenIsOn = `mainFromHome`;
      this.setFlipCardScreenIsOn({screenIsOn});
      this.unsetShowMobileFlipCard();
    }

    const callNotification = ({msg}) => {
      console.log(msg);
      if(document.getElementById(`floater-${this.state.addExistObj.floater_profile_id}`)) document.getElementById(`floater-${this.state.addExistObj.floater_profile_id}`).style.opacity = 1;
      this.destroyAtomNotification({all:true, fromWhere: 'ChoiceButton error'});
      this.callHookForMessageAlert({
        type: 'error',
        content: `${msg}`,
        title: 'Error Notification',
        duration: 20,
      });
    }

    const postObj = {
      floater_profile_id: this.state.addExistObj.floater_profile_id,
      focusPrid: this.state.addExistObj.focusPrid,
      rel: relationship,
      dropOnPrId: this.state.addExistObj.dropOnPrId,
      marriageId,
      callNotification,
    };

    // console.log(`postObj: `, JSON.stringify(postObj, null, 2));

    this.cleanUp({closePedigreeAddbox: true});
    this.props.postAddExisting(postObj)

  }

  gatherDropNodesWithinViewport({floatingPrId, skipGhostNodes}){

    const isGhostFlaggedWithAddable = (nodeObj) =>{
      return (nodeObj.nt === 'ghost' && typeof(nodeObj.a) !== 'undefined')
    }

    const nodeIsViewable = (nodeObj) => {
      return typeof(nodeObj.nvp) === 'undefined' && nodeObj.nt !== 'ghost'
    }

    const floatingNodeAndDropOnNodeIsDifferent = ({nodeObj, floatingPrId}) => {
      return typeof(floatingPrId) === 'undefined' || nodeObj.pr_id !== floatingPrId;
    }

    const tempViewportBuffer =  10;
    const dragFloaterFilter = (nodeObj) => {
      return (nodeIsViewable(nodeObj)  || isGhostFlaggedWithAddable(nodeObj)) &&
          isNodeWithinViewport( { nodeObj, viewPortSides, viewPortBuffer: tempViewportBuffer }) &&
          floatingNodeAndDropOnNodeIsDifferent({nodeObj, floatingPrId})
    };

    const dragOverAndDropFilter = (nodeObj) => {
      return nodeIsViewable(nodeObj) && typeof(nodeObj.e) !== 'undefined' && isNodeWithinViewport( { nodeObj, viewPortSides, viewPortBuffer: tempViewportBuffer })
    };

    let filterHow = (nodeObj) => {
      return ( typeof(skipGhostNodes) !== 'undefined'  ?
                            dragOverAndDropFilter(nodeObj) :
                            dragFloaterFilter(nodeObj) )
    }

    const { nodeObjs, viewPortSides } = this.props;
    let nodeObjsInViewPort = {};
    for (let n in nodeObjs) {
      var nodeObj = nodeObjs[n];
      if( filterHow(nodeObj) ) {
        nodeObjsInViewPort[n] = nodeObj;
      };
    }
    return nodeObjsInViewPort;
  }

  setDropOnNode(node){
    if(this.props.dropOnNode === node) return;
    this.setState({
      dropOnNode: node
    });
  }

  setIsDraggingFloater(how){
    this.isDraggingFloater = how;
    if( this.props.chartType === 'fan') this.fanChartComponent.current.setFloaterActive(how)
  }

  dropOnTargetForCtrlKeyDnMoveFeature(){
    if (typeof(this.dropOnTargetNode) === 'undefined') return;
    this.setDropOnNode(this.dropOnTargetNode)

    const stageLeft =  Math.round(this.stage.current.position().x / this.stage.current.scaleX()) * -1;
    const stageTop =  (Math.round(this.stage.current.position().y / this.stage.current.scaleX()) * -1);
    const nodeLeft = this.props.nodeObjs[this.dropOnTargetNode].left;
    const nodeTop = this.props.nodeObjs[this.dropOnTargetNode].top;
    const pedigreeParentNodeId = this.props.nodeObjs[this.dropOnTargetNode].pedigreeParentNodeId;

    if(this.props.nodeObjs[this.dropOnTargetNode].nt === 'ghost' ||
      this.props.nodeObjs[this.dropOnTargetNode].isPedigreeGhost){

      this.confirmDropOnGhost({
          floaterObj: this.state.dragNodeObj,
          node: ( this.props.isPedigree ? pedigreeParentNodeId: this.dropOnTargetNode)});

    } else{

      const addExistObj = {
        floater_profile_id: this.state.dragNodeObj.pr_id,
        focusPrid: this.props.nodeObjs[this.props.focusNode].pr_id,
        dropOnPrId: this.props.nodeObjs[this.dropOnTargetNode].pr_id,
        dropOnNode: this.dropOnTargetNode,
        floaterFirstName: this.state.dragNodeObj.fn,
        floaterGender: this.state.dragNodeObj.g,
        node: this.dropOnTargetNode,
      };

      this.setAddExistObj(addExistObj);

      this.setMoveDecisionPanelPos({
        left: ( nodeLeft - stageLeft) * this.stage.current.scaleX(),
        top:  ( nodeTop - stageTop) * this.stage.current.scaleX(),
      })

      this.setMoveDecisionPanelVisible(true);

    }

  }

  showDragNodeWhenCntrlKeyDn(){
      return this.state.moveOperationWithCtrlKeyDnActivated &&
        typeof(this.state.dragNodeObj) !== 'undefined' &&
        typeof(this.state.dragNodeObj.n) !== 'undefined'
  }

  setLastMouseOverTargetForDroppingCntrlDragNode(node){
    this.dropOnTargetNode = node;
  }

  highlight(node, fromWhere){
    doWhenReady({
      argument: {},
      condition: ()=>{
        return typeof(this.refs[`node-${node}`]) !== 'undefined'
      },
      callback: () =>{
        this.refs[`node-${node}`].addHighlight(true, node);
        typeof(this.highlightNodes) !== 'undefined' && !this.highlightNodes.includes(node) && this.highlightNodes.push(node);
      },
      attempts: {ongoing:0, end: 9999999},
      fromWhere: 'setReduxCanvasHeightTop',
    })
  }

  unhighlight(node){

    if(typeof(node) !== 'undefined'){
      if(typeof(node) !== 'undefined' &&
         typeof(this.refs[`node-${node}`]) !== 'undefined'){
        this.refs[`node-${node}`].addHighlight(false, node);
      }
    } else {

      while( typeof(this.highlightNodes) !== 'undefined' && this.highlightNodes.length > 0 ){
        const highlightNode = this.highlightNodes.pop();
        if(typeof(highlightNode) !== 'undefined' &&
           typeof(this.refs[`node-${highlightNode}`]) !== 'undefined'){
          this.refs[`node-${highlightNode}`].addHighlight(false, highlightNode);
        }
      }
    }
  }

  setCntrlDragNodeObj(node){
    if( this.cntrlDragNode === node) return;
    this.cntrlDragNode = node;
    this.setState({
      dragNodeObj: ( node ? this.nodeObjs[node]: undefined)
    });
  }

  setMoveDecisionPanelPos({left, top}){
    this.setState({
      moveDecisionPanelPos: {left,top}
   });
  }

  setMoveHelpPos({changeX, changeY}){
    const { right, top } = this.state.moveHelpPos;
    this.setState({
      moveHelpPos: {
        right: right - changeX,
        top: top + changeY}
   });
   // console.log(JSON.stringify(this.state.moveHelpPos, null, 2));
  }

  resetMoveHelpPos(){
    this.setState({
      moveHelpPos: {
        right: 267,
        top: this.props.canvasTop,
      }
   });
  }

  setAddExistObj({
    floater_profile_id,
    focusPrid,
    rel,
    dropOnPrId,
    dropOnNode,
    floaterFirstName,
    floaterGender,
    node,
  }){


    // console.log(`{->`, JSON.stringify({
    //   floater_profile_id,
    //   focusPrid,
    //   rel,
    //   dropOnNode,
    //   dropOnPrId,
    //   floaterFirstName,
    //   floaterGender,
    //   node,
    // }, null, 2));



    this.setState({
      addExistObj:{
        floater_profile_id,
        focusPrid,
        dropOnPrId,
        dropOnNode,
        floaterFirstName,
        floaterGender,
      },

   });
   if(typeof(node) !== 'undefined') this.highlightNode = node;
  }

  floaterExist(prId){
    return findIndexInData(this.props.floaters, 'pr_id', prId) !== -1;
  }

  shouldShowFloaterHelp(){
    const bool = typeof(this.props.preferences.get('show_floaters_help')) !== 'undefined' &&
        this.props.preferences.get('show_floaters_help') === 1;
    return bool;
  }

  addFloater(prId){
    const callbackAfterAddedFloater = ()=>{
      if( this.shouldShowFloaterHelp() ){
        this.setShowMoveHelp(true);
      }
    }
    this.props.addFloater({prId, callbackAfterAddedFloater})
  }

  setShowFloaterPanel(bool){
    this.setState({
      showFloaterPanel: bool
    });
    this.redraw({});
  }

  setActivateDesignateDragOrDropTarget(bool){
    this.setState({
      activateDesignateDragOrDropTarget: bool
    });
  }

  setMoveDecisionPanelVisible(bool){
    this.setState({
      moveDecisionPanelVisible: bool
    });
    if(!bool){
      this.unOpacityFloaters();
    }
  }

  unOpacityFloaters(){
    if(document.getElementById(`floater-${this.state.addExistObj.floater_profile_id}`)) document.getElementById(`floater-${this.state.addExistObj.floater_profile_id}`).style.opacity = 1;
  }

  setShowMoveHelp(bool){
    this.setState({showMoveHelp: bool});
  }

  confirmDropOnGhost({floaterObj, node}){

    this.dropOnGhostConfirming = true;

    let rel = (this.props.isPedigree ? 'parent': 'partner');

    let marriageId = ( this.props.isPedigree ? undefined: this.findMariage(parseInt(node, 10)));

    if( marriageId === '-1'){ // Typically union/marriageId is -1 when there is two ghost unions

      marriageId = undefined;

      rel = 'parent';

      node = this.findSingleChildOfGhost(parseInt(node, 10));

    }

    this.setAddExistObj({
      floater_profile_id: floaterObj.pr_id,
      focusPrid: this.nodeObjs[this.props.focusNode].pr_id,
      dropOnPrId: this.nodeObjs[node].pr_id,
      floaterFirstName: floaterObj.fn,
      floaterGender: floaterObj.g,
    })

    this.highlightNode = node;

    const phrase = (
      isDevelopment
        ?
      floaterObj.nm + ' will be dropped here.'
        :
      window.trl('{profile} will be dropped here.', null, { profile: floaterObj.nm }));

    this.callHookForMessageAlert({
      type: 'info',
      content: phrase,
      title: this.translatedLabels['Notification'].translatedLabel,
      duration: 2000,
      confirmLabel: this.translatedLabels['Yes, proceed'].translatedLabel,
      okLabel: this.translatedLabels['Cancel'].translatedLabel,
      okCallback: ()=>{
        if(document.getElementById(`floater-${floaterObj.pr_id}`)) document.getElementById(`floater-${floaterObj.pr_id}`).style.opacity = 1;
        this.unhighlight();
        this.dropOnGhostConfirming = false;
        this.setShowFloaterPanel(true);
        this.redraw({});
      },
      confirmCallback: ()=>{

        this.destroyAtomNotification({all:true, fromWhere: 'after drop on ghost saga'});

        const callNotification = ({msg}) => {
          console.log(msg);
          this.destroyAtomNotification({all:true, fromWhere: 'after drop on ghost saga'});
          this.callHookForMessageAlert({
            which: 'confirmDropOnGhost',
            type: 'error',
            content: `${msg}`,
            title: 'Error Notification',
            duration: 2000,
          });
        }

        this.cleanUp({closePedigreeAddbox: true});

        this.props.postAddExisting({
          floater_profile_id: floaterObj.pr_id,
          focusPrid: this.nodeObjs[this.props.focusNode].pr_id,
          rel,
          dropOnPrId: this.nodeObjs[node].pr_id,
          marriageId,
          callNotification,
        })
      }
    });
  }

  findMariage(node){

    return compact(this.unions.map(  obj => {
      const pair = obj.p;
      if( pair[0] === node || pair[1] === node) {
       return obj.m;
      } else{
        return null;
      }

    }))[0];
  }

  findSingleChildOfGhost(node){
    return compact(this.unions.map(  obj => {
      const pair = obj.p;
      const m = obj.m;
      if( (pair[0] === node || pair[1] === node) && m === '-1') {
       return obj.c[0];
      } else{
        return null;
      }

    }))[0];
  }

  launchMoveDecisonPanel(){

    if(typeof(this.state.dragNodeObj) === 'undefined' ||
       typeof(this.nodeObjs[this.state.dropOnNode]) === 'undefined'
    ) return;

    this.setAddExistObj({
      floater_profile_id: this.state.dragNodeObj.pr_id,
      focusPrid: this.nodeObjs[this.props.focusNode].pr_id,
      dropOnPrId: this.nodeObjs[this.state.dropOnNode].pr_id,
      dropOnNode: this.state.dropOnNode,
      floaterFirstName: this.state.dragNodeObj.fn,
      floaterGender: this.state.dragNodeObj.g,
    })

    this.setMoveDecisionPanelVisible(true);
  }


}


export default Move;
